<template>
  <!-- 公用组件  -->
  <div class="input_one" @dblclick="dblclick" :class="isactive?'input_one_active':''">
    <span class="label_name" :class="isMust?'isMust':''">{{name}}</span>
    <!-- <i class="el-icon-question icon_sty"  v-if="isquestion"></i> -->
    <el-input
      v-model="value1"
      size="mini"
      :clearable="true"
      :placeholder="placeholder"
      class="input_sty"
      @focus="doFocus"
      @blur="doBlur"
      :disabled="isdisable"
      @input="changeVal"
    ></el-input>
    <i :class="icon" v-show="show" class="icon_st" @click="$emit('clickclose')"></i>
    <i :class="icon1" class="icon_sty" @click="$emit('clickAdd')"></i>
    <i :class="icon2" class="icon_sty" @click="$emit('clickSearch')"></i>
  </div>
</template>

<script>
export default {
  name: "InputOne",
  data() {
    return {
      value1: this.value,
      isactive: false,
      show: false
    };
  },
  methods: {
   
    // 双击事件
    dblclick() {
      this.$emit("dblclick");
    },
    // 聚焦事件
    doFocus() {
      this.$emit("clickFocus");
      this.isactive = true;
    },
    // 失焦事件
    doBlur() {
      this.$emit("Blur");
      this.isactive = false;
    },
    // 绑定input事件进行回调传值
    changeVal() {
      this.$emit("changeVal", this.value1, this.field);
    }
  },
  props: {
    value: [String, Number],
    name: {
      type: String,
      default: "筛选条件"
    },
    placeholder: {
      type: String,
      default: "筛选条件"
    },
    isMust: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: "el-icon-circle-close"
    },
    icon1: {
      type: String,
      default: "el-icon-plus"
    },
    icon2: {
      type: String,
      default: "el-icon-search"
    },
    isdisable: {
      type: Boolean,
      default: false
    },
    // 传入的外部字段，将用于传出识别
    field: { type: String }
  },
  watch: {
    value() {
      this.value1 = this.value;
      if (this.value != "") {
        this.show = true;
      } else if (this.value == "") {
        this.show = false;
      }
    }
  }
};
</script>

<style lang="less">
.input_one {
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: flex-end;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding-right: 5px;
  .el-input--suffix {
    width: 100%;
    position: relative;
    .el-input__inner {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      border: none;
      height: 27px;
      line-height: 27px;
      padding: 0;
      text-indent: 14px;
      font-size: 13px;
    }
  }

  .label_name {
    height: 100%;
    text-align: center;
    white-space: nowrap;
    line-height: 28px;
    font-size: 12px;
    margin-left: 5px;
    font-weight: bold;
  }
  .isMust::after {
    content: "*";
    color: red;
  }
  .input_sty {
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    display: block;
    height: 100%;
  }
  .icon_sty {
    margin-top: 6px;
  }
  .icon_st {
    color: #ccc;
    font-size: 14px;
    line-height: 26px;
  }
}
.input_one:hover {
  border-color: #2594ff;
  color: #2594ff;
  .icon_sty {
    color: #000 !important;
  }
}
.input_one_active {
  border-color: #2594ff !important;
  color: #2594ff !important;
  .icon_sty {
    color: #000 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/elasticinput/elasticinput.vue